import React from 'react';
import './HowItWorks.css';

const HowItWorks: React.FC = () => {
  const helpSteps = [
    {
      number: '1',
      title: 'Request Help',
      description: 'Describe your issue — flat tire, dead battery, lockout — and share your location.',
      icon: '🆘'
    },
    {
      number: '2',
      title: 'Get Matched',
      description: 'Our algorithm connects you with a nearby helper based on skills, ratings, and availability.',
      icon: '🎯'
    },
    {
      number: '3',
      title: 'Help Arrives',
      description: 'Track your helper in real-time, communicate securely, and get back on the road.',
      icon: '📍'
    }
  ];

  const learnSteps = [
    {
      number: '1',
      title: 'Pick a Skill',
      description: 'Browse tutorials for oil changes, tire care, fluid checks, and other everyday maintenance.',
      icon: '📚'
    },
    {
      number: '2',
      title: 'Follow the Guide',
      description: 'Work through step-by-step instructions with safety tips, tool lists, and video walkthroughs.',
      icon: '🔧'
    },
    {
      number: '3',
      title: 'Learn from a Local',
      description: 'Connect with an experienced community member who can teach you hands-on or answer your questions.',
      icon: '👨‍🏫'
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works">
      <div className="how-it-works-container">
        <div className="how-it-works-header">
          <h2 className="how-it-works-title">How It Works</h2>
          <p className="how-it-works-subtitle">
            Two ways to use GetStrandX — get help when you're stuck, or learn skills so you're prepared next time
          </p>
        </div>

        <div className="paths-container">
          <div className="path-section">
            <h3 className="path-title">🆘 Need Roadside Help?</h3>
            <div className="steps-container">
              {helpSteps.map((step, index) => (
                <div key={index} className="step-card">
                  <div className="step-number">{step.number}</div>
                  <div className="step-content">
                    <div className="step-icon">{step.icon}</div>
                    <h4 className="step-title">{step.title}</h4>
                    <p className="step-description">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="path-section">
            <h3 className="path-title">🔧 Want to Learn DIY?</h3>
            <div className="steps-container">
              {learnSteps.map((step, index) => (
                <div key={index} className="step-card">
                  <div className="step-number">{step.number}</div>
                  <div className="step-content">
                    <div className="step-icon">{step.icon}</div>
                    <h4 className="step-title">{step.title}</h4>
                    <p className="step-description">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
